import TargetMenuModal from 'components/TargetMenuModal';
import service from 'features/DailyMenu/services';
import { CommonResponse, TargetMenu } from 'models';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { TARGET_MENU_DAILY_MENU } from 'utils';

interface AddDailyMenuButtonProps {
  dailyId: number;
  weeklyName: string;
}

function AddDailyMenuButton({ dailyId, weeklyName }: AddDailyMenuButtonProps) {
  const { t } = useTranslation();

  // states
  const [isOpenTargetMenuModal, setIsOpenTargetMenuModal] = useState(false);

  // events
  function handleOpenOverlayMenuModal() {
    setIsOpenTargetMenuModal(true);
  }

  function handleCloseOverlayMenuModal() {
    setIsOpenTargetMenuModal(false);
  }

  function handleLoadData(): Promise<CommonResponse<TargetMenu[]>> {
    return service.listMenus(dailyId);
  }

  function handleAdd(menuIds: number[]): Promise<CommonResponse<any>> {
    // compose add payload with overlayGroupId
    return service.addMenus(dailyId, menuIds);
  }

  function handleDelete(menuIds: number[]): Promise<CommonResponse<any>> {
    // compose delete payload with overlayGroupId
    return service.deleteMenus(dailyId, menuIds);
  }

  return (
    <>
      <Button className="ms-3" onClick={handleOpenOverlayMenuModal}>
        {t('DailyMenu.Button.target_menu')}
      </Button>
      {isOpenTargetMenuModal &&
        createPortal(
          <TargetMenuModal
            targetSourceType={TARGET_MENU_DAILY_MENU}
            targetName={weeklyName}
            onLoadData={handleLoadData}
            onAdd={handleAdd}
            onDelete={handleDelete}
            onClose={handleCloseOverlayMenuModal}
          />,
          document.body
        )}
    </>
  );
}

export default AddDailyMenuButton;
